module.exports = __webpack_public_path__ + "static/media/n.433651d8.svg";